exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title-tips[data-v-4a8070f6]{padding-bottom:10px;font-size:14px;color:#333}.title-tips span[data-v-4a8070f6]{margin-right:14px;color:#999}", ""]);

// exports
